// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1-2ky","rootSmall":"AddTileButton_rootSmall__1chUW"};